import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@core/services/logging.service';
import { ServerTokensService } from '@core/services/server-tokens.service';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
    private readonly httpTimeout: number;

    constructor(private logging: LoggingService, private serverTokens: ServerTokensService) {
        this.httpTimeout = this.serverTokens.httpTimeoutSeconds * 1000;
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            timeout(this.httpTimeout),
            catchError(error => {
                if (error instanceof TimeoutError) {
                    this.logging.logMessage(
                        'Timeout Error',
                        `Request to "${request.url}" cancelled by FE after ${this.httpTimeout}ms`
                    );
                }
                return throwError(error);
            })
        );
    }
}
